<template>
	<div id="app" v-on:click="hideMobileNav">
		<Header />

		<router-view />

		<MobileNav />
	</div>
</template>

<script>
import { auth } from "./firebase"
import Header from "./components/Header"
import MobileNav from "./components/MobileNav"

export default {
	components: {
		Header,
		MobileNav,
	},
	methods: {
		hideMobileNav() {
			this.$store.dispatch("hideMobileNav")
		},
	},
	created() {
		auth.onAuthStateChanged((user) => {
			if (user) {
				this.$store.dispatch("getLeagues")
			}
		})

		auth.signInAnonymously()
	},
}
</script>

<style></style>
